import { render, staticRenderFns } from "./ArticleHeading.vue?vue&type=template&id=331536ce&scoped=true&"
import script from "./ArticleHeading.vue?vue&type=script&lang=js&"
export * from "./ArticleHeading.vue?vue&type=script&lang=js&"
import style0 from "./ArticleHeading.vue?vue&type=style&index=0&id=331536ce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331536ce",
  null
  
)

export default component.exports